<template>
  <div class="isis-page__header md-layout">
    <div class="md-layout-item md-size-100">
      <div class="nav-link" @click="goToPreviousPage()">
        <i class="fas fa-chevron-left"></i>
        <span
          >{{ mainTaskName }} <md-icon>arrow_right</md-icon>
          {{ subtaskName }}</span
        >
      </div>
    </div>
    <div class="md-layout-item md-size-100">
      <md-card v-if="subtaskDetail">
        <md-card-content>
          <SubtaskForm
            :subtask-data="subtaskDetail"
            :type="subtaskDetail.type"
            mode="edit"
            :main-task-id="subtaskDetail.main_task_id"
          ></SubtaskForm>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import { service_names } from "../../../constants/Services";
import { hasHistory } from "@/helpers/utils";
import SubtaskForm from "../Component/SubtaskForm";

export default {
  components: { SubtaskForm },
  data() {
    return {
      subtaskId: this.$route.params.id,
      subtaskDetail: null,
      mainTaskName: "",
      subtaskName: ""
    };
  },
  created() {
    this.$axios
      .get(`${service_names.school}/sub-task/${this.subtaskId}`)
      .then(({ data }) => {
        this.subtaskDetail = data;
        this.mainTaskName = data.main_tasks.project_name;
        this.subtaskName = data.task_name;
      });
  },
  methods: {
    goToPreviousPage() {
      hasHistory()
        ? this.$router.go(-1)
        : this.$router.push("/task-management");
    }
  }
};
</script>
